import { Pipe, PipeTransform } from '@angular/core';
import { Permission } from '@rivethealth/data/user-account';
import { PermissionsState } from '../account/permissions-state.service';

@Pipe({ name: 'locked' })
export class LockedPipe implements PipeTransform {
  constructor(private readonly permissionsState: PermissionsState) {}

  transform(permission: Permission) {
    return !this.permissionsState.isAllowed(permission);
  }
}
